export const MetersNames: any = {
    cold_water: "Холодная вода",
    hot_water: "Горячая вода",
    gas:"Газ",
    electricity:"Электричество",
    membership_fee:"Членский взнос",
    reimbursement_fee:"Возместительный взнос",
    communication_fee:"Коммуникационный сбор",
    targeted_fee:"Целевой взнос",
    other_fee:"Прочее"
};
